import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, ShieldCheck, Lock, CreditCard, Mail } from 'lucide-react';
import { Button } from './ui/Button';
export const Hero = () => {
  return <section className="relative overflow-hidden bg-cream-50 pt-16 pb-20 md:pt-24 md:pb-28" data-id="element-122">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[400px] bg-celeste-100/50 rounded-full blur-3xl -z-10 opacity-70" data-id="element-123"></div>

      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-125">
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-1.5 text-sm font-heading font-extrabold uppercase tracking-[0.15em] text-stone-700 shadow-sm ring-1 ring-celeste-200 mb-6" data-id="element-126">
            <span className="text-base leading-none" data-id="element-127">🐦‍🔥</span>
            <span data-id="element-128">
              TU FÉNIX <span className="text-[#44403C]" data-id="element-129">DIGITAL</span>
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tight text-stone-900 mb-6 leading-tight text-center" data-id="element-130">
            Todo tu año de clases <br data-id="element-131" />
            <span className="text-celeste-600" data-id="element-132">Pronto</span> <br data-id="element-133" />
            <span className="text-celeste-600" data-id="element-134">Desde hoy</span>
          </h1>

          <div className="mb-6 flex justify-center" data-id="element-135">
            <span className="inline-block rounded-full bg-celeste-600 px-5 py-2 text-base md:text-xl font-extrabold uppercase tracking-wide text-white shadow-lg shadow-celeste-500/25" data-id="element-136">
              tu fenix digital PRESENTA
            </span>
          </div>

          <div className="mb-8 flex justify-center" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/jXPMg7AVq1uD69r85Tc4vF/ChatGPT_Image_23_jun_2026,_04_16_19_p.m..png" alt="Aula de Éxitos™ — Recursos digitales para primaria: Física y Química, Ciencias de la Tierra, Historia, Geografía, Ciudadanía" className="w-full max-w-3xl h-auto rounded-2xl" loading="eager" data-id="element-138" />
          </div>

          <div className="mb-8 max-w-3xl mx-auto space-y-3" data-id="element-139">
            <p className="text-base sm:text-lg md:text-2xl text-stone-700 font-bold leading-snug px-2" data-id="element-140">
              El sistema que maestras y maestros en Uruguay ya prefieren para su
              planificación en el Tramo 2 (EBI).
            </p>
            <p className="text-sm sm:text-base md:text-xl text-stone-600 font-semibold leading-snug px-2" data-id="element-141">
              Física y Química · Ciencias de la Tierra · Historia · Geografía ·
              Ciudadanía.
            </p>
            <p className="text-2xl sm:text-3xl md:text-4xl text-emerald-600 font-extrabold leading-tight" data-id="element-142">
              Todo el año resuelto.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-white rounded-2xl shadow-lg border-2 border-celeste-100 p-6 md:p-8 max-w-4xl mx-auto mb-10" data-id="element-143">
          <h2 className="text-2xl md:text-3xl font-extrabold text-stone-900 mb-6 leading-snug text-center" data-id="element-144">
            Planificaciones + fichas de alumno + evaluaciones listas para usar.{' '}
            <br data-id="element-145" />
            <span className="text-emerald-600" data-id="element-146">
              Sin buscar. Sin armar. <br data-id="element-147" />
              Sin perder fines de semana.
            </span>
          </h2>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-sm font-medium text-stone-600" data-id="element-148">
            <div className="flex items-center gap-1.5 bg-cream-50 px-3 py-1.5 rounded-lg" data-id="element-149">
              <FileText className="w-4 h-4 text-celeste-500" data-id="element-150" />
              <span data-id="element-151">100% PDF</span>
            </div>
            <div className="flex items-center gap-1.5 bg-cream-50 px-3 py-1.5 rounded-lg" data-id="element-152">
              <Zap className="w-4 h-4 text-amber-500" data-id="element-153" />
              <span data-id="element-154">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-1.5 bg-cream-50 px-3 py-1.5 rounded-lg" data-id="element-155">
              <span className="text-base leading-none" data-id="element-156">🇺🇾</span>
              <span data-id="element-157">Tramo 2 · EBI</span>
            </div>
            <div className="flex items-center gap-1.5 bg-cream-50 px-3 py-1.5 rounded-lg" data-id="element-158">
              <BookOpen className="w-4 h-4 text-celeste-500" data-id="element-159" />
              <span data-id="element-160">6 Tomos listos</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-161">
          <Button href="#comprar" variant="secondary" size="xl" className="w-full sm:w-auto mb-6 text-lg shadow-celeste-500/20 shadow-xl" data-id="element-162">
            QUIERO MI KIT AULA DE ÉXITOS AHORA!
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-stone-500 font-medium" data-id="element-163">
            <div className="flex items-center gap-1.5" data-id="element-164">
              <ShieldCheck className="w-4 h-4 text-emerald-500" data-id="element-165" />
              <span data-id="element-166">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-167">
              <Lock className="w-4 h-4 text-stone-400" data-id="element-168" />
              <span data-id="element-169">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-170">
              <CreditCard className="w-4 h-4 text-stone-400" data-id="element-171" />
              <span data-id="element-172">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};